// extracted by mini-css-extract-plugin
export default {"container":"v0-z","list":"w0-z"};